module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-form"
  }, [_c('el-alert', {
    staticClass: "err",
    attrs: {
      "title": "Error logging in",
      "type": "error"
    }
  }), _vm._v(" "), _c('el-form', {
    ref: "credentials",
    staticClass: "login-form",
    attrs: {
      "model": _vm.credentials,
      "rules": _vm.validators
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "username"
    }
  }, [_c('el-input', {
    staticClass: "login-input",
    attrs: {
      "type": "text",
      "placeholder": "Email or Username"
    },
    model: {
      value: (_vm.credentials.username),
      callback: function($$v) {
        _vm.$set(_vm.credentials, "username", $$v)
      },
      expression: "credentials.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('el-input', {
    staticClass: "login-input",
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "Password"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.submit('credentials')
      }
    },
    model: {
      value: (_vm.credentials.password),
      callback: function($$v) {
        _vm.$set(_vm.credentials, "password", $$v)
      },
      expression: "credentials.password"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "fpLink",
    on: {
      "click": _vm.forgotPassword
    }
  }, [_vm._v("Forgotten Password?")]), _vm._v(" "), _c('div', {
    staticClass: "login-btns"
  }, [_c('el-button', {
    attrs: {
      "type": "add"
    },
    on: {
      "click": function($event) {
        _vm.submit('credentials')
      }
    }
  }, [_vm._v("Login")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1198ebbb","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoginForm.vue
// module id = 642
// module chunks = 2 15